// extracted by mini-css-extract-plugin
export default {"SectionHeader":"_SectionHeader--H3jxo"};